import { useContext } from 'react';
import { createContext } from 'react';

import { ProductPriceSavingsProps } from '../@types/ProductPriceSavingsProps';

export const ProductPriceSavingsContext = createContext<ProductPriceSavingsProps>({} as ProductPriceSavingsProps);

ProductPriceSavingsContext.displayName = 'ProductPriceSavings';

const ProductPriceSavingsProvider = (props: ProductPriceSavingsProps) => (
	<ProductPriceSavingsContext.Provider value={props}>{props.children}</ProductPriceSavingsContext.Provider>
);

export const useProductPriceSavings = () => {
	const context = useContext(ProductPriceSavingsContext);

	return context;
};

export default ProductPriceSavingsProvider;
